<template>
  <div class="mb-5">
    <div class="mt-5 row">
      <div class="mx-auto col-lg-9 col-xs-12">
        <b-breadcrumb :items="items"></b-breadcrumb>
        <b-overlay :show="showLoading" rounded="sm">
          <template #overlay>
            <div class="text-center">
              <b-spinner label="Spinning"></b-spinner>
              <p>
                <strong>{{ msgProcesso }}</strong>
                <b-progress variant="warning" class="mb-3" :max="max">
                  <b-progress-bar
                    class="text-dark"
                    style="font-weight: bold"
                    :value="value"
                    :label="`${((value / max) * 100).toFixed(0)}%`"
                  ></b-progress-bar>
                </b-progress>
              </p>
            </div>
          </template>

          <b-card>
            <div class="alert alert-success" v-if="sucesso">
              {{ sucesso }}
            </div>
            <div class="alert alert-warning" v-if="alerta">⚠️{{ alerta }}</div>
            <div class="alert alert-danger" v-if="error">{{ error }}</div>
            <b-card-header size="sm">
              <div align="right">
                <button
                  @click="criar()"
                 
                  class="btn btn-success"
                >
                  <font-awesome-icon
                    :icon="['fas', 'ticket']"
                    title="Criar Vouchers"
                  />
                  Criar Vouchers
                </button>
              </div>
            </b-card-header>

            <b-table
              no-provider-paging
              small
              responsive
              :empty-text="tabela.emptyText"
              :fields="tabela.fields"
              :items="tabela.items"
              :show-empty="tabela.showEmpty"
              :striped="tabela.striped"
              :current-page="tabela.currentPage"
              :per-page="tabela.perPage"
              bordered
            >
              <template v-slot:cell(voucher_criado)="data">
                <b-badge
                  v-if="data.item.voucher"
                  variant="success"
                  class="text-white"
                  >Sim</b-badge
                >
                <b-badge v-else variant="warning" class="text-white"
                  >Não</b-badge
                >
              </template>
              <template v-slot:cell(inserir)="data">
                <b-button
                  v-if="
                    data.item.voucher && data.item.flag_voucher_enviado == 0
                  "
                  variant="primary"
                  size="sm"
                  @click="acionarApiBH(data.item)"
                >
                  <font-awesome-icon
                    :icon="['fas', 'plus']"
                    title="Inserir Beneficiário no sistema do BH"
                  />
                  Inserir
                </b-button>
              </template>
            </b-table>
            <b-card-footer size="sm">
              <div class="row">
                <div class="col">
                  <b-input-group
                    class="quantidade-registros"
                    prepend="Quantidade Sem Voucher"
                  >
                    <b-input
                      disabled
                      class="quantidade-registros bg-warning text-white"
                      v-model="tabela.totalRowsSemVoucher"
                    >
                      {{ tabela.totalRowsSemVoucher }}
                    </b-input>
                  </b-input-group>
                </div>
                <div class="col">
                  <b-input-group
                    class="quantidade-registros"
                    prepend="Quantidade Com Voucher"
                  >
                    <b-input
                      disabled
                      class="quantidade-registros bg-success text-white"
                      v-model="tabela.totalRowsComVoucher"
                    >
                      {{ tabela.totalRowsComVoucher }}
                    </b-input>
                  </b-input-group>
                </div>
                <div class="col">
                  <b-pagination
                    align="right"
                    :total-rows="tabela.totalRows"
                    v-model="tabela.currentPage"
                    :per-page="tabela.perPage"
                  >
                  </b-pagination>
                </div>
              </div>
            </b-card-footer>
          </b-card>
        </b-overlay>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      showBtCriar: true,
      value: 0,
      max: 0,
      showLoading: false,
      msgProcesso: null,
      parametrosData: {},
      items: [{ text: "Criar Voucher Famílias", active: true }],
      error: null,
      sucesso: null,
      alerta: null,
      prazo: 3,
      tabela: {
        currentPage: 1,
        items: [],
        fields: [
          {
            key: "cpf_resp",
            label: "CPF",
            class: "text-center",
          },
          {
            key: "nome_responsavel",
            label: "Nome",
            class: "text-center",
          },
          {
            key: "voucher_criado",
            label: "Voucher Criado",
            class: "text-center",
          },
          {
            key: "inserir",
            label: "Inserir Supermercados BH",
            class: "text-center",
          },
        ],
        showEmpty: true,
        emptyText: "Nenhum registro encontrado",
        striped: true,
        perPage: 10,
        totalRowsSemVoucher: 0,
        totalRowsComVoucher: 0,
        totalRows:0
        
      },
    };
  },
  computed: {
    http() {
      return this.$store.getters.http;
    },
  },
  methods: {
    pesquisar() {
      if (this.tabela.currentPage == 1) {
        this.listarFamilias();
      } else {
        this.tabela.currentPage = 1;
      }
    },

    listarFamilias() {
      this.error = null;
      this.alerta = null;
      this.sucesso = null;
      try {
        this.$store.commit("setLoading", true);
        this.http
          .get(`/admin/listar-familias-sem-voucher`, {
            headers: { Authorization: `Bearer ${this.$store.getters.token}` },
            params: {
              paginacao: JSON.stringify(this.tabela.paginacao),
            },
          })
          .then((response) => {
            if (response.status == 200) {
              let semVoucher = 0;
              let comVoucher = 0;
              response.data.dados.dados.forEach((element) => {
                element.control = Math.random();
                if (element.voucher) {
                  comVoucher = comVoucher + 1;
                }
                if (!element.voucher) {
                  semVoucher = semVoucher + 1;
                }
                this.tabela.items.push(element);
              });
              this.tabela.totalRowsSemVoucher = semVoucher;
              this.tabela.totalRowsComVoucher = comVoucher;
              this.tabela.totalRows = this.tabela.items.length;
              this.$store.commit("setLoading", false);
            }
          });
      } catch (error) {
        this.$store.commit("setLoading", false);
        this.error = error;
      }
    },

    verificarDatas() {
      this.error = null;
      var atual = moment().format("YYYYMMDD");
      var dataFinalVoucher = moment(
        this.parametrosData.datafinalvoucher,
        "DD/MM/YYYY"
      ).format("YYYYMMDD");
      var data1 = moment(atual, "YYYYMMDD");
      var data2 = moment(dataFinalVoucher, "YYYYMMDD");
      var diferenca = data2.diff(data1, "days");
      if (atual >= dataFinalVoucher) {
        this.error =
          "Não é possível gerar voucher. Data atual é maior ou igual a data final de validade do voucher.";
        return false;
      }
      if (diferenca < 3) {
        if (diferenca == 2) {
          this.prazo = diferenca;
        } else if (diferenca == 1) {
          this.prazo = diferenca;
        }
        return true;
      } else {
        return true;
      }
    },

    criar() {
      this.error = null;
      this.alerta = null;
      this.sucesso = null;
      let validacao = this.verificarDatas();
      if (validacao) {
        try {
          this.max = 0;
          this.value = 0;
          (this.msgProcesso =
            "Criando voucher(s) para o(s) beneficiário(s). Aguarde..."),
            (this.showLoading = true);
          let params = {
            mes: this.parametrosData.mes,
            ano: this.parametrosData.ano,
            prazo: this.prazo,
          };
          this.http
            .post(`/admin/criar-vouchers`, params, {
              headers: { Authorization: `Bearer ${this.$store.getters.token}` },
            })
            .then((response) => {
              if (response.data.status == 200) {
                let semVoucher = 0;
                let comVoucher = 0;
                this.tabela.items = [];
                this.sucesso = response.data.dados.message;
                this.showLoading = false;
                response.data.dados.dados.forEach((element) => {
                  element.control = Math.random();
                  if (element.voucher) {
                    comVoucher = comVoucher + 1;
                  }
                  if (!element.voucher) {
                    semVoucher = semVoucher + 1;
                  }
                  this.tabela.items.push(element);
                });
                this.tabela.totalRowsSemVoucher = semVoucher;
                this.tabela.totalRowsComVoucher = comVoucher;
                this.totalRows = this.tabela.items.length;
              } else {
                this.alerta = response.data.dados.message;
                this.showLoading = false;
              }
            });
        } catch (error) {
          this.showLoading = false;
          this.error = error;
        }
      }
    },

    async acionarApiBH(item) {
      this.error = null;
      this.alerta = null;
      this.sucesso = null;

      this.$store.commit("setLoading", true);
      let params = {
        cpf_resp: item.cpf_resp,
      };
      await this.http
        .post(`/admin/acionar-api-bh`, params, {
          headers: { Authorization: `Bearer ${this.$store.getters.token}` },
        })
        .then((response) => {
          if (response.data.status == 200) {
            this.$store.commit("setLoading", false);
            this.sucesso = response.data.dados.message;
            this.excluirItem(item);
          } else {
            this.$store.commit("setLoading", false);
            this.error = response.data.dados.message;
          }
        })
        .catch((error) => {
          this.error = this.$store.commit("setLoading", false);
          let erro429 = error.response.data.error.message.search("429");
          if (erro429 > 0) {
            this.error =
              "Somente é permitido uma requisição a cada 10 segundos para a API do Supermercados BH. " +
              "Aguarde mais alguns instantes para tentar novamente.";
          } else {
            this.error = error.response.data.error.message;
          }
        });
    },

    excluirItem(item) {
      var index = this.tabela.items.findIndex(
        (element) => element.control === item.control
      );
      if (index > -1) {
        this.tabela.items.splice(index, 1);
        let qtdComVoucherAtual = this.tabela.totalRowsComVoucher;
        this.tabela.totalRowsComVoucher = qtdComVoucherAtual - 1;
      }
    },

    async buscarParams() {
      try {
        let { data } = await this.http.get(`/admin/params`, {
          headers: { Authorization: `Bearer ${this.$store.getters.token}` },
        });
        this.parametrosData = data.dados;
      } catch (error) {
        this.error = error;
      }
    },
  },
  mounted() {
    this.listarFamilias();
    this.buscarParams();
  },
};
</script>

<style scoped>
.error {
  color: #dc3545;
  text-align: right;
}
</style>
